import { atom } from "recoil"

export const unreadThreadCountRequestIdState = atom<number>({
  key: "atoms/contact/unreadThreadCountRequestIdState",
  default: 0,
})
